import {
  Loader,
  LoaderProps,
  LoadingOverlay as MantineLoadingOverlay,
  LoadingOverlayProps as MantineLoadingOverlayProps,
  Stack,
  Text,
  TextProps
} from '@mantine/core'
import { ReactNode, useMemo } from 'react'

type LoadingOverlayProps = MantineLoadingOverlayProps & {
  loaderSize?: LoaderProps['size']
  textSize?: TextProps['size']
  withSpinner?: boolean
  message?: ReactNode
}

export const LoadingOverlay = ({
  loaderSize = 'md',
  textSize = 'sm',
  withSpinner = true,
  message,
  ...props
}: LoadingOverlayProps) => {
  const loaderContent = useMemo(() => {
    if (!withSpinner && !message) {
      return ' ' // use empty string to hide the spinner
    }

    return (
      <Stack align="center" gap="xl">
        {withSpinner && <Loader size={loaderSize} />}

        {message && (
          <Text size={textSize} fs="italic" ta="center">
            {message}
          </Text>
        )}
      </Stack>
    )
  }, [loaderSize, textSize, withSpinner, message])

  return (
    <MantineLoadingOverlay
      loaderProps={{ children: loaderContent }}
      overlayProps={{
        backgroundOpacity: 0.7
      }}
      {...props}
    />
  )
}
